import { render, staticRenderFns } from "./ReportMealsSelectCompanyField.vue?vue&type=template&id=a68080c0"
import script from "./ReportMealsSelectCompanyField.vue?vue&type=script&lang=js"
export * from "./ReportMealsSelectCompanyField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports